// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_em-0";
export var fileCarousel = "_em-2";
export var removeFileButton = "_em-1";